// extracted by mini-css-extract-plugin
export default {"error":"HcrbJOy8hkIgw1QFH9dF"};